// Pure helpers for the Store Velocity & Stats report (Reporting -> Store Reports).

const csvCell = v => {
    if (v === null || v === undefined) return '';
    const s = String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

// Order-list lines -> CSV text (header row first).
export function buildCsv(rows) {
    const header = ['SKU', 'Product', 'Size', 'Color', 'Qty', 'B2B stock'];
    const out = [header.join(',')];
    (rows || []).forEach(r => {
        out.push([r.sku, r.product, r.size, r.color, r.qty, r.b2b_stock].map(csvCell).join(','));
    });
    return out.join('\n');
}

// Plain-text order: one "SKU × qty — product (size/color)" per line + a total line.
export function orderListText(lines, storeName) {
    const ls = lines || [];
    const body = ls.map(l => {
        const opts = [l.size, l.color].filter(Boolean).join('/');
        return `${l.sku} × ${l.qty} — ${l.product || ''}${opts ? ` (${opts})` : ''}`;
    });
    const total = ls.reduce((s, l) => s + (Number(l.qty) || 0), 0);
    const head = storeName ? [`Order for ${storeName}`, ''] : [];
    return [...head, ...body, '', `Total: ${total} units`].join('\n');
}

// Sort a copy: nulls always last, numbers numerically, strings case-insensitively.
export function applySort(rows, key, dir) {
    const mult = dir === 'desc' ? -1 : 1;
    return [...(rows || [])].sort((a, b) => {
        const x = a[key];
        const y = b[key];
        const xn = x === null || x === undefined || x === '';
        const yn = y === null || y === undefined || y === '';
        if (xn && yn) return 0;
        if (xn) return 1;
        if (yn) return -1;
        if (typeof x === 'number' && typeof y === 'number') return (x - y) * mult;
        return String(x).localeCompare(String(y), undefined, { numeric: true, sensitivity: 'base' }) * mult;
    });
}

// Word-by-word: every typed word must appear in sku, product, description, brand or category.
export function filterRows(rows, { q } = {}) {
    const words = String(q || '').toLowerCase().split(/\s+/).filter(Boolean);
    if (!words.length) return rows || [];
    return (rows || []).filter(r => {
        const hay = [r.sku, r.product, r.description, r.brand, r.category].map(v => String(v || '').toLowerCase()).join(' ');
        return words.every(w => hay.includes(w));
    });
}
